import * as React from 'react';
import { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import {
	Avatar,
	Box,
	Button,
	Menu,
	MenuItem,
	Typography,
} from '@mui/material';
import EarthIcon from "../../../assets/images/icons/toolbar/earthIcon";
import useUserAction from "../../../hooks/user/useUserAction";
import useUserData from "../../../hooks/user/useUserData";
import { useTranslation } from "react-i18next";
import { Languages } from "../../../helpers/constants";
import Images from "../../../assets";

const LanguageSelect = () => {
	const theme = useTheme();
	const { setUserLanguage } = useUserAction()
	const { language } = useUserData()
	const { i18n } = useTranslation()
	useEffect(() => {
		i18n.changeLanguage(language)
	}, [i18n, language])
	
	const [anchorEl, setAnchorEl] = React.useState(null)
	const open = Boolean(anchorEl)
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(null)
	}
	const handleListItemClick = (lang) => {
		setUserLanguage(lang);
	}

	return (
		<React.Fragment>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					textAlign: 'center',
					flexShrink: 0,
					ml: 1,
					zIndex: 1
				}}
			>
				<Button
					aria-label="open localization"
					// ref={anchorRef}
					aria-controls={open ? 'localization-grow' : undefined}
					aria-haspopup="true"
					onClick={handleClick}
					size={'small'}
					color={"highlight"}
					startIcon={<EarthIcon/>}
					variant={'contained'}
					sx={{
						minHeight: '2.5rem',
						mixWidth: '5.438rem',
						background: open && theme.palette.highlight.dark
					}}
				>
					<Typography
						component={'span'}
						variant={'button'}
					>
						{language === Languages.EN ? 'EN' : 'EL'}
					</Typography>
				</Button>
			</Box>
			<Menu
				anchorEl={anchorEl}
				id="account-menu"
				open={open}
				onClose={handleClose}
				onClick={handleClose}
				slotProps={{
					paper: {
						elevation: 0,
						sx: {
							overflow: 'visible',
							filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
							mt: 1.5,
							p: '8px 10px',
							borderRadius: '12px',
							// minWidth: '135px',
							// minHeight: '128px',
							'& .MuiAvatar-root': {
								width: 24,
								height: 24,
								ml: -0.5,
								mr: 1,
							},
							'&::before': {
								content: '""',
								display: 'block',
								position: 'absolute',
								top: 0,
								right: 20,
								width: 12,
								height: 12,
								bgcolor: 'background.paper',
								transform: 'translateY(-50%) rotate(45deg)',
								zIndex: 0,
								borderRadius: '2px',
							},
						},
					},
				}}
				transformOrigin={{ horizontal: 'right', vertical: 'top' }}
				anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
			>
				<MenuItem
					sx={{
						display: 'flex',
						gap: '4px',
						pt: '8px',
						// pr: '24px',
						pb: '8px'
					}}
					// selected={language === Languages.EN}
					onClick={() => handleListItemClick(Languages.EN)}
				>
					<Avatar src={Images.englishFlag} alt={'English flag'}/>
					<Typography
						variant={'body1'}
						sx={{ lineHeight: '1.125rem' }}
						color={'text.main'}
					>English</Typography>
				</MenuItem>
				<MenuItem
					sx={{
						display: 'flex',
						gap: '4px',
						pt: '8px',
						// pr: '24px',
						pb: '8px'
					}}
					// selected={language === Languages.EL}
					onClick={() => handleListItemClick(Languages.EL)}
				>
					<Avatar src={Images.greekFlag} alt={'Greek flag'}/>
					<Typography
						variant={'body1'}
						sx={{ lineHeight: '1.125rem' }}
						color={'text.main'}
					>Ελληνικά</Typography>
				</MenuItem>
			</Menu>
		</React.Fragment>
	);
};

export default LanguageSelect;
